var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c-info_svg__nc-icon-wrapper",
    fill: "#111",
    stroke: "#111"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    "data-stroke": "none",
    cx: 8.5,
    cy: 5,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 8.5,
    cy: 8.5,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.5 12.5v-4"
  }))));
}

export default SvgCInfo;